import { ProductNameType } from "graphql/generated";
import { ENV_CONFIG } from "src/utils/envConfig";

export const useGetProductFromConfig = (productNameType: ProductNameType) => {
  if (!productNameType) return null;

  const stripeProduct = ENV_CONFIG?.stripeProduct;

  return stripeProduct?.find((product) => product.uniqName === productNameType);
};

export default useGetProductFromConfig;
